import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en_CA from "./locales/en_CA.json";
import zh_CN from "./locales/zh_CN.json";
import zh_HK from "./locales/zh_HK.json";
import fr_CA from "./locales/fr_CA.json";

i18n.use(initReactI18next).init({
  resources: {
    en_CA: {
      translation: en_CA,
    },
    zh_CN: {
      translation: zh_CN,
    },
    zh_HK: {
      translation: zh_HK,
    },
    fr_CA: {
      translation: fr_CA,
    },
  },
  lng: "en_CA",
  fallbackLng: "en_CA",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
